import React from "react";
import style from "./Perks.module.css";
import Card from "./Card/Card";
import cx from "classnames";
function Perks() {
  return (
    <div className={style.wrapper}>
      <div className={style.innerContainer}>
        <div className={style.detailsDiv}>
          <h1 className={style.heading}>
            Perks & <strong>Benefits</strong>
          </h1>
          <p className={style.description}>
            InvoZone takes care of its employees. Let’s take a look how do we do
            that!
          </p>
        </div>
        <div className={style.cardsWrapper}>
          <div className={cx(style.singleCardRow, style.firstRow)}>
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Paid-Leaves.svg"
              heading="Paid Leaves"
              description="We understand your responsibilities in your life. Hence, here are 24 leaves for you all!"
            />
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Timings.svg"
              heading="Flexible Timing"
              description="Can’t reach at 9 a.m. sharp? Don’t worry, join us whenever you can and enjoy our culture!"
            />
          </div>
          <div className={cx(style.singleCardRow, style.secondRow)}>
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Gratuity.svg"
              heading="Gratuity"
              description="All employees should be taken care of according to the rules of Labour Laws. Enough said!"
            />
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Medical.svg"
              heading="Medical Coverage"
              description="We really hope you don’t have to use the benefit of having In-Patient/Out-Patient coverage!"
            />
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Gaming.svg"
              heading="Gaming Facility"
              description="Office doesn’t have to be boring. Light up the atmosphere and enjoy with your colleagues"
            />
          </div>
          <div className={cx(style.singleCardRow, style.thirdRow)}>
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Annual-Increment.svg"
              heading="Annual Increment"
              description="If you value us and the work that you do, we will value the time you have given to us!"
            />
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Gym.svg"
              heading="Gym Allowance"
              description="We focus on health & fitness. Our team should not have pot bellies!"
            />
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Personal-Growth.svg"
              heading="Personal Development Fund"
              description="Be at ease while working, get the right peripherals & hardware to get the right productivity!"
            />
          </div>
          <div className={cx(style.singleCardRow, style.fourthRow)}>
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Training-Fund.svg"
              heading="Training Fund"
              description="We enable our team to aim for professional certificates helping them achieve greater feats!"
            />
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Vehicle.svg"
              heading="Vehicle Lease"
              description="InvoZone puts forward solutions towards car financing and transportation."
            />
          </div>
          <div className={cx(style.singleCardRow, style.fifthRow)}>
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Weekends.svg"
              heading="Weekends are off!"
              description="We work so hard that we require two days of rest every week!"
            />
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Part-of-growing-team.svg"
              heading="Growing & Dynamic Team"
              description="A growing team provides more learning opportunity than any other typical workplace."
            />
            <Card
              imgSrc="https://invozone.com/wp-content/uploads/2020/07/Development.svg"
              heading="Personal & Professional Growth"
              description="Attend seminars, exhibitions or webinars to build yourself an unparalleled profile!"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Perks;
